<template>
  <div class="mobile-navbar only-mobile">
    <MobileLogo :isBackgroundPrimary="isBackgroundPrimary" :screenLevel="screenLevel" />
    <HamburgerIcon
      :isContactPanelActive="isContactPanelActive"
      :isBackgroundPrimary="isBackgroundPrimary"
      :isMobileNavOpen="isMobileNavOpen"
      :screenLevel="screenLevel"
    />
  </div>
</template>

<script>
import MobileLogo from "./MobileLogo";
import HamburgerIcon from "./HamburgerIcon";

export default {
  name: "MobileNavBar",
  components: {
    HamburgerIcon,
    MobileLogo
  },
  props: {
    isBackgroundPrimary: Boolean,
    isMobileNavOpen: Boolean,
    isContactPanelActive: Boolean,
    screenLevel: String
  }
};
</script>

<style lang='scss' scoped>
.mobile-navbar {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 50;
  padding: 26px 6%;
  background-color: $primary-color;
  color: #fff;
  transition: 0.4s ease-in-out;

  &--white {
    background-color: #fff;
    color: $primary-color;
  }
}
</style>